import React from "react";
import { FormattedMessage } from "react-intl";
import { Timer } from "../../campaign-parts/timer";
import { PollSlideType } from "../../poll";

export function Character({
    characterName,
    conversationName,
    timer,
    lang,
    handleLinkClick,
    trackButtonClick,
    isLocked = false,
    pollSlideOptions,
    latest,
    handleModalOpen,
    pollId,
}: {
    characterName: string;
    conversationName: string;
    timer: string | null;
    lang: string;
    handleLinkClick: (cta: InboxCTA) => void;
    trackButtonClick: (
        id: string,
        label?: string,
        additionalInformation?: Record<string, unknown>,
    ) => void;
    isLocked?: boolean;
    pollSlideOptions?: PollSlideType["options"];
    latest: boolean;
    handleModalOpen: (params: {
        characterName: string;
        conversationName: string;
        handleLinkClick: (cta: InboxCTA) => void;
        trackButtonClick: (
            id: string,
            label?: string,
            additionalInformation?: Record<string, unknown>,
        ) => void;
        pollSlideOptions?: PollSlideType["options"];
        pollId?: string;
    }) => void;
    pollId?: string;
}) {
    return (
        <div
            className={`character ${isLocked ? "locked" : ""} ${latest ? "latest" : ""} character-${conversationName}`}
            onClick={
                !latest || conversationName === "date6"
                    ? () =>
                          handleModalOpen({
                              characterName,
                              conversationName,
                              handleLinkClick,
                              trackButtonClick,
                              pollSlideOptions,
                              pollId,
                          })
                    : undefined
            }
        >
            <div className="image"></div>
            {timer !== null && lang !== undefined && (
                <div className="timer-container">
                    <div className="timer-label">
                        <FormattedMessage id="globalText.langVelvetGlitchUnlockingIn" />
                    </div>
                    <Timer timerString={timer} lang={String(lang)} />
                </div>
            )}
        </div>
    );
}
